// extracted by mini-css-extract-plugin
export default {"table":"Marche_table__Uu7CI"};